export default __webpack_public_path__ + "static/media/folder.d224a20f.png";